import { render, staticRenderFns } from "./widget_notifications.vue?vue&type=template&id=afc6dd40&"
import script from "./widget_notifications.vue?vue&type=script&lang=js&"
export * from "./widget_notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports